import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router';
import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers';
import { useLayout } from '../../../core';
import { t } from 'i18next';
import CustomizePopup from '../../../../../common/CustomizePopUp';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { UpdateCurrentPopupId } from '../../../../../common/GlobalSlice';
import CustomizeTooltip from '../../../../../common/CustomizeTooltip';

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  hasBullet?: boolean;
};

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { app } = config;
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);
  const dispatch = useAppDispatch();
const {showSubMenus, currentPopupId} = useAppSelector((state)=> state.globalState);
const togglePopup = () => {
  if (iconRef.current) {
    const rect = iconRef.current.getBoundingClientRect();
    setPopupPosition({
      top: rect.top + window.scrollY + rect.height,
      left: rect.left + window.scrollX + rect.width,
    });
  }
  if (currentPopupId === to) {
    dispatch(UpdateCurrentPopupId(null));
  } else {
    dispatch(UpdateCurrentPopupId(to));
  }
};

const closePopup = () => {
  dispatch(UpdateCurrentPopupId(null));
};
const isPopupOpen = currentPopupId === to;
  return (
    <>
      <div
        className={clsx('menu-item', { 'here show': isActive }, 'menu-accordion')}
        data-kt-menu-trigger="click"
        style={{backgroundColor: isPopupOpen ? "#EEEEEE" : ""}}
      >
        <span className='menu-link' onClick={togglePopup}>
          {hasBullet && (
            <span className='menu-bullet'>
              <span className='bullet bullet-dot'></span>
            </span>
          )}
          {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
            <span className='menu-icon' ref={iconRef}>
              {showSubMenus ? (
              <CustomizeTooltip content={title} position="right">
              <KTIcon iconName={icon} className='fs-2' />
              </CustomizeTooltip>
              ) : (
                <KTIcon iconName={icon} className='fs-2' />
              )}
            </span>
          )}
          {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
            <i className={clsx('bi fs-3', fontIcon)}></i>
          )}
          <span className='menu-title'>{t(title)}</span>
          <span className='menu-arrow'></span>
        </span>
        {!showSubMenus && (
        <div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
          {children}
        </div>
        )}
      </div>

      {showSubMenus && <CustomizePopup
        onClose={closePopup}
        isOpen={isPopupOpen}
        top={popupPosition.top}
        left={popupPosition.left}
        isActive={isActive}
        popupHeading={title}
      >
        {children}
        </CustomizePopup>}
    </>
  );
};

export { SidebarMenuItemWithSub };
